import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {
    getAdvertisementLoginSettings,
    updateAdvertisementLoginSettings,
} from 'src/openapi/admin/apis/AdvertisementLoginSettingsApi';
import {useAppDispatch} from 'src/store/hooks';

import type {AdvertisementLoginSettings} from 'src/openapi/admin/models/AdvertisementLoginSettings';

type Props = {
    conferenceId: number,
};

export const useAdvertisementLogin = ({conferenceId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback((signal: AbortSignal) => apiDispatch(
        getAdvertisementLoginSettings({conferenceId}, {signal}),
    ), [conferenceId, apiDispatch]);

    const saveDispatchAction = useCallback((
        advertisementLoginSettings: AdvertisementLoginSettings,
        signal: AbortSignal,
    ) => apiDispatch(updateAdvertisementLoginSettings({
        conferenceId,
        advertisementLoginSettings,
    }, {signal})), [conferenceId, apiDispatch]);

    return useCommonDataHook({
        initValue: {advertiseOnLoginTime: 0},
        getDispatchAction,
        saveDispatchAction,
    });
};
